/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { Slot, SlotProps } from '@radix-ui/react-slot'
import { useSetAtom } from 'jotai'
import React from 'react'

import { BasketItem, addItemAtom } from '@/store/basket'

/** A description of available properties for this component. */
type AddToBasketWrapperProps = SlotProps & {
  /** The item that is being added to the basket. */
  item: BasketItem
}

/**
 * A wrapper component that is used to add an item to the basket. Used as a wrapper component around other elements, i.e.
 * buttons, icons, etc. to add an item to the basket.
 */
const AddToBasketWrapper: React.FC<AddToBasketWrapperProps> = ({ item, ...props }) => {
  const addItem = useSetAtom(addItemAtom)

  /**
   * Handles the click event for adding an item to the basket.
   */
  const handleAddToBasket = () => {
    addItem(item)
  }

  return <Slot onClick={handleAddToBasket} {...props} />
}

export { AddToBasketWrapper }
